// eslint-disable-next-line
export default function (date) {
  return /(\d{4}-\d{2}-\d{2}).+(\d{4}-\d{2}-\d{2})/g.test(date);
}
